import { useTranslation } from 'react-i18next';
import { useDeleteProcessField } from 'api/services/dataTableService';
import { ProcessField, CustomProcessField } from 'types/dataTableTypes';
import { useFloatNotification } from 'contexts/FloatNotificationContext';
import { ErrorType } from 'types/genericTypes';
import { GenericDeleteModal } from '../GenericDeleteModal';

type DeleteFieldModalProps = {
  displayDeleteModal: boolean;
  onCancel: () => void;
  field: ProcessField | CustomProcessField | undefined;
  processId: string;
};

export const DeleteFieldModal = ({
  displayDeleteModal,
  onCancel,
  field,
  processId,
}: DeleteFieldModalProps) => {
  const { t } = useTranslation();
  const { mutateAsync: deleteField } = useDeleteProcessField();
  const { openNotification } = useFloatNotification();

  const handleDeleteField = async () => {
    try {
      await deleteField({
        processId,
        fieldId: field?.id || '',
      });

      openNotification(
        t('success'),
        t('data-tables.field-modal.delete-success'),
        'success'
      );
    } catch (err) {
      const apiError = err as ErrorType;
      if (apiError.body?.errorCode) {
        openNotification(t('error'), t(apiError.body.errorCode), 'error');
      } else {
        openNotification(
          t('error'),
          t('data-tables.field-modal.delete-error'),
          'error'
        );
      }
    }

    onCancel();
  };

  return (
    <GenericDeleteModal
      open={displayDeleteModal}
      onCancel={onCancel}
      onOk={handleDeleteField}
      bodyTitle={t('data-tables.field-modal.delete-modal-body-title', {
        fieldName: field?.name ?? '',
        count: (field as CustomProcessField)?.formCount ?? 0,
      })}
    />
  );
};
